import type { EntryPointComponent } from 'react-relay';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';

import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingsServicedeskNotificationsInternalNotificationsRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskNotificationsInternalNotificationsRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { LazyInternalNotificationSettingsPage } from '@jira/servicedesk__notification-internal/src/LazyInternalNotificationSettingsPage.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import type { Route } from '@atlassian/react-resource-router';
import { ServiceDeskInternalNotificationsNextGenRedirect } from './ui/service-desk-internal-notifications-next-gen-redirect/index.tsx';
import { LazyProjectSettingsServiceDeskInternalNotifications } from './ui/service-desk-internal-notifications/index.tsx';

const projectSettingsServicedeskNotificationsInternalNotificationsPageEntryPoint =
	createPageEntryPoint({
		main: {
			root: JSResourceForUserVisible<EntryPointComponent<{}, {}, {}, {}>>(
				/* webpackChunkName: "async-project-settings-servicedesk-notifications-internal-notifications" */ './ui/service-desk-internal-notifications-next-gen-redirect/index.tsx',
				{ entryFsSsrLiftImportToModule: false },
			),
			getPreloadProps: () => ({}),
		},
	});

export const projectSettingsServicedeskNotificationsInternalNotificationsRouteEntry: Route =
	createEntry(
		projectSettingsServicedeskNotificationsInternalNotificationsRoute,

		() => ({
			group: 'project-settings-servicedesk',
			ufoName: 'service-management.internal-notifications',

			// eslint-disable-next-line no-restricted-syntax
			component: fg('nike_entrypoint_migration_batch_2')
				? undefined
				: ServiceDeskInternalNotificationsNextGenRedirect,

			entryPoint: () =>
				fg('nike_entrypoint_migration_batch_2')
					? projectSettingsServicedeskNotificationsInternalNotificationsPageEntryPoint
					: undefined,
			layout: serviceProjectLayout,

			navigation: {
				menuId: MenuIdProjects,
				sidebarId: SidebarIdProjectSettings,
			},

			resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],

			forPaint: [
				LazyProjectSettingsServiceDeskInternalNotifications,
				LazyInternalNotificationSettingsPage,
			],

			bifrost: {
				bifrostGroup: 'shell-only',
			},
		}),
	);
